// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"style_notFoundContainer__5miV6","imageContainer":"style_imageContainer__-+01s"};